import { removeUrlParams } from '@cascade/core/utils';
import { useEffect, useState } from 'react';
import {
  isOnPathname,
  readSearchParams,
} from './useConsumedSearchParams.helpers.ts';
import type { TConsumedSearchParamsOptions } from './useConsumedSearchParams.types.ts';

export const useConsumedSearchParams = (
  names: readonly string[],
  { pathname }: TConsumedSearchParamsOptions = {},
): URLSearchParams => {
  const [params] = useState(() =>
    isOnPathname(window.location.pathname, pathname)
      ? readSearchParams(window.location.href, names)
      : new URLSearchParams(),
  );

  useEffect(() => {
    if (!isOnPathname(window.location.pathname, pathname)) {
      return;
    }

    const cleanHref = removeUrlParams(window.location.href, names);

    if (cleanHref !== window.location.href) {
      window.history.replaceState(window.history.state, '', cleanHref);
    }
  }, [names, pathname]);

  return params;
};
